<template>
  <div
    class="info-block"
    tabindex="0"
    :aria-label="name + ' ' + value"
  >
    <p>{{value}}</p>
    <div>{{name}}</diV>
  </div>
</template>

<script>
export default {
  name: 'select-buttom',
  props: ['name', 'value'],
  components: {
  },
  data() {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
  .info-block {
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
    width: 9.5rem;
    height: 5.25rem;
    border-radius: 5px;
    background-color: #ebe6e6;
    padding: 0.5rem;
    box-sizing: border-box;
    p {
      color: #df2860;
      font-family: 'Poppins', sans-serif;
      font-size: 1.5rem;
      font-weight: 500;
      text-align: center;
          white-space: nowrap;

    }
    div {
      color: #a491b8;
      font-family: 'Poppins', sans-serif;
      font-size: 0.65rem;
      text-transform: uppercase;
      text-align: center;
    }
  }
</style>
